export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-film-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg text-background-50">吃瓜视频</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed max-w-md">
                吃瓜视频是国内领先的热点娱乐视频在线播放平台，提供最新吃瓜视频免费在线观看，海量热点娱乐视频每日更新，即点即看无需等待。无论是娱乐圈八卦、社会热点还是网络热议话题，吃瓜视频都能让你第一时间掌握最新动态。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">吃瓜热榜</a>
                <a href="#updates" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">实时动态</a>
                <a href="#cards" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">精选推荐</a>
                <a href="#faq" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-400">更多合作伙伴即将入驻，敬请期待。</p>
            </div>
          </div>

          <div className="border-t border-background-600 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">© 2026 吃瓜视频 版权所有</p>
            <p className="text-xs text-background-400">最新吃瓜视频免费看高清入口 — 即点即看无需等待</p>
          </div>
        </div>
      </div>
    </footer>
  );
}